(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["grid-item-media"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nw-grid-media')) {
    customElements.define('nw-grid-media', class extends HTMLElement {
      connectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.initFrame = requestAnimationFrame(() => {
          if (this.isConnected) this.initialize();
        });
      }
      initialize() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.item = this.closest('.grid-item');
        this.mediaLink = this.querySelector('[data-grid-media-link]');
        this.productButtons = Array.from(this.item.querySelectorAll('[data-grid-product-button]'));
        this.frames = Array.from(this.querySelectorAll('.nw-grid-media__frame'));
        this.index = Math.max(0, this.frames.findIndex(frame => frame.classList.contains('is-active')));
        this.randomRemaining = this.frames.map((_, index) => index).filter(index => index !== this.index);
        this.busy = false;
        this.focused = false;
        this.arrowsHovered = false;
        const imageArea = this.closest('.grid-item__inner');
        // Cover can render an image wider than its box when filling a tall crop.
        // Tell srcset that effective width, letting the browser account for DPR.
        const updateImageSizes = () => {
          this.querySelectorAll('img[width][height][srcset]').forEach(image => {
            const width = image.clientWidth;
            const height = image.clientHeight;
            const ratio = Number(image.getAttribute('width')) / Number(image.getAttribute('height'));
            if (!width || !height || !Number.isFinite(ratio) || ratio <= 0) return;
            const fit = getComputedStyle(image).objectFit;
            const effectiveWidth = fit === 'cover' ? Math.max(width, height * ratio) : width;
            image.sizes = `${Math.ceil(effectiveWidth)}px`;
          });
        };
        this.imageSizeObserver?.disconnect();
        this.imageSizeObserver = new ResizeObserver(updateImageSizes);
        this.imageSizeObserver.observe(imageArea);
        updateImageSizes();
        const hoverArrows = this.querySelector('[data-step]') && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        if (hoverArrows) {
          this.arrowsHovered = imageArea.matches(':hover');
          imageArea.addEventListener('mouseenter', () => {
            clearTimeout(this.arrowExitTimer);
            this.arrowsHovered = true;
            this.schedule();
          }, options);
          imageArea.addEventListener('mouseleave', () => {
            clearTimeout(this.arrowExitTimer);
            this.arrowExitTimer = setTimeout(() => {
              this.arrowsHovered = false;
              this.schedule();
            }, 220);
          }, options);
        }
        this.classList.remove('is-product-hovered');
        this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.querySelectorAll('[data-step]').forEach(button => {
          button.hidden = false;
          button.addEventListener('click', event => {
            event.preventDefault();
            event.stopPropagation();
            this.change(Number(button.dataset.step));
          }, options);
        });
        this.dots = Array.from(this.querySelectorAll('[data-media-index]'));
        const dotNavigation = this.querySelector('.nw-grid-media__dots');
        if (dotNavigation) dotNavigation.hidden = false;
        this.dots.forEach(button => button.addEventListener('click', async event => {
          event.preventDefault();
          event.stopPropagation();
          await this.change(0, false, Number(button.dataset.mediaIndex));
          this.schedule();
        }, options));
        document.addEventListener('visibilitychange' , () => this.schedule(), options);
        this.item.addEventListener('mouseenter', () => { this.classList.add('is-product-hovered'); }, options);
        this.item.addEventListener('mouseleave', () => { this.classList.remove('is-product-hovered'); }, options);
        this.item.addEventListener('focusin', () => { this.focused = this.item.matches(':has(:focus-visible)'); this.schedule(); }, options);
        this.item.addEventListener('focusout', event => {
          this.focused = this.item.contains(event.relatedTarget) && event.relatedTarget.matches(':focus-visible');
          this.schedule();
        }, options);
        this.syncProduct();
        this.schedule();
      }
      syncProduct() {
        const frame = this.frames[this.index];
        if (!frame) return;
        this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.index)));
        if (this.mediaLink) {
          this.mediaLink.hidden = !frame.dataset.mediaUrl;
          if (frame.dataset.mediaUrl) this.mediaLink.setAttribute('href', frame.dataset.mediaUrl);
          else this.mediaLink.removeAttribute('href');
          this.mediaLink.setAttribute('aria-label', frame.dataset.mediaLabel || '');
          if (frame.dataset.productUrl && this.dataset.productNewTab !== 'true') {
            this.mediaLink.removeAttribute('target');
            this.mediaLink.removeAttribute('rel');
          } else {
            this.mediaLink.setAttribute('target', '_blank');
            this.mediaLink.setAttribute('rel', 'noopener noreferrer');
          }
        }
        this.productButtons.forEach(button => {
          button.hidden = !frame.dataset.productUrl;
          if (frame.dataset.productUrl) button.setAttribute('href', frame.dataset.productUrl);
          else button.removeAttribute('href');
          const title = frame.dataset.productButtonTitle || frame.dataset.productTitle || '';
          button.setAttribute('aria-label', title);
          button.querySelector('span').textContent = title;
        });
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.frames.length < 2 || this.dataset.autoplay !== 'true' || this.paused || this.arrowsHovered || this.focused || document.hidden || !this.isConnected) return;
        this.timer = setTimeout(async () => {
          await this.change(1, true);
          this.schedule();
        }, Math.max(1, Math.min(10, Number(this.dataset.speed) || 3)) * 1000);
      }
      async change(step, automatic = false, targetIndex = null) {
        if (this.busy || this.frames.length < 2 || targetIndex === this.index) return;
        this.busy = true;
        const signal = this.controller.signal;
        const random = automatic && this.dataset.randomOrder === 'true';
        let next = targetIndex === null ? (this.index + step + this.frames.length) % this.frames.length : targetIndex;
        if (random) {
          if (!this.randomRemaining.length) this.randomRemaining = this.frames.map((_, index) => index);
          const candidates = this.randomRemaining.filter(index => index !== this.index);
          next = candidates[Math.floor(Math.random() * candidates.length)];
        }
        const images = Array.from(this.frames[next].querySelectorAll('img')).filter(image => !image.closest('.nw-grid-media__hover-wrap'));
        try {
          await Promise.all(images.map(image => {
            image.loading = 'eager';
            return image.decode();
          }));
          if (signal.aborted || !this.isConnected) return;
          if (automatic && (this.arrowsHovered || this.focused || this.paused || document.hidden)) return;
          this.frames[this.index].classList.remove('is-active');
          this.frames[this.index].setAttribute('aria-hidden', 'true');
          this.frames[next].classList.add('is-active');
          this.frames[next].setAttribute('aria-hidden', 'false');
          this.index = next;
          this.syncProduct();
          if (random) this.randomRemaining.splice(this.randomRemaining.indexOf(next), 1);
          else this.randomRemaining = this.frames.map((_, index) => index).filter(index => index !== next);
        } catch {
          return;
        } finally {
          if (!signal.aborted) this.busy = false;
        }
      }
      disconnectedCallback() {
        this.imageSizeObserver?.disconnect();
        cancelAnimationFrame(this.initFrame);
        clearTimeout(this.arrowExitTimer);
        clearTimeout(this.timer);
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
